import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EditTwoToneSvg from "@ant-design/icons-svg/es/asn/EditTwoTone";
import AntdIcon from "../components/AntdIcon";
var EditTwoTone = function EditTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EditTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EditTwoTone.displayName = 'EditTwoTone';
}
export default /*#__PURE__*/React.forwardRef(EditTwoTone);